export default __webpack_public_path__ + "static/media/pantalon-militar-mujer.c8c4c30d.png";